module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Alec Karys-314434a2cacc9076d9fd9b5485aa4221.png";